import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const HeadTitle = props =>
  <Helmet>
    <title>OTC Markets - TPS | {props.title}</title>
  </Helmet>;

HeadTitle.propTypes = {
  title: PropTypes.string.isRequired
};
export default HeadTitle;
